import styled from "styled-components";

/** Flag glyph column — a fixed width so the endonyms line up under one another. */
export const Flag = styled.span`
	font-size: 16px;
	line-height: 1;
	width: 20px;
	text-align: center;
	flex: none;
`;

/** Endonym label; grows so the active-locale check sits flush right. */
export const Endonym = styled.span`
	flex: 1;
`;
